import { fetchJson } from "../lib/api";

export type SupplierSourceKind = "pdf" | "ugl" | "datanorm";

export type SupplierSourceExpectation = "required" | "optional" | "absent";

export type SupplierSourceProfileProvenance =
  | "configured"
  | "fallback"
  | "unconfigured";

export type SupplierSourceProfileCheckKind =
  | "parse_validation_line"
  | "reconciliation_supplier_case"
  | "set_price_qa_set";

export type SupplierSourceProfileCheckStatus =
  | "active"
  | "waiting_for_source"
  | "not_applicable";

export type SupplierSourceProfileSource = {
  source: SupplierSourceKind;
  expectation: SupplierSourceExpectation;
  observed: boolean;
  supported: boolean;
};

export type SupplierSourceProfileCheck = {
  kind: SupplierSourceProfileCheckKind;
  status: SupplierSourceProfileCheckStatus;
  reason: string;
};

export type SupplierSourceProfile = {
  supplier: string;
  revision: string;
  provenance: SupplierSourceProfileProvenance;
  updated_at: string | null;
  reason: string | null;
  sources: SupplierSourceProfileSource[];
  checks: SupplierSourceProfileCheck[];
};

export type SupplierSourceProfilesResponse = {
  customer_id: string;
  profiles: SupplierSourceProfile[];
};

export type UpdateSupplierSourceProfileInput = {
  supplier: string;
  expectedRevision: string;
  requestId: string;
  expectations: Record<SupplierSourceKind, SupplierSourceExpectation>;
  reason: string;
};

export async function fetchSupplierSourceProfiles(): Promise<SupplierSourceProfilesResponse> {
  return fetchJson<SupplierSourceProfilesResponse>(
    "/api/source-coverage/profiles",
  );
}

export async function updateSupplierSourceProfile(
  input: UpdateSupplierSourceProfileInput,
): Promise<SupplierSourceProfile> {
  return fetchJson<SupplierSourceProfile>(
    `/api/source-coverage/profiles/${encodeURIComponent(input.supplier)}`,
    {
      method: "POST",
      body: JSON.stringify({
        expected_revision: input.expectedRevision,
        request_id: input.requestId,
        expectations: input.expectations,
        reason: input.reason,
      }),
    },
  );
}

export async function previewSupplierSourceProfile(input: {
  supplier: string;
  expectations: Record<SupplierSourceKind, SupplierSourceExpectation>;
}): Promise<SupplierSourceProfile> {
  return fetchJson<SupplierSourceProfile>(
    `/api/source-coverage/profiles/${encodeURIComponent(input.supplier)}/preview`,
    {
      method: "POST",
      body: JSON.stringify(input.expectations),
    },
  );
}
